<template>
  <b-card
    no-body
    class="back-overflow border-primary btn p-0"
    @click="buttonClick"
  >
    <div class="bg-light-primary rounded-top text-center">
      <b-img
        v-if="object_info.image"
        :src="object_info.image.url"
        :alt="object_info.title"
        height="170"
      />
      <b-img
        v-else
        :src="require('@/assets/images/pages/login/login_main.svg')"
        :alt="object_info.title"
        height="170"
        style="object-fit: cover; width: 100%; opacity: 0.4;"
      />
    </div>
    <div
      class="pt-1 back-size-pos"
      :class="{'bg-light-info':!object_info.image}"
    >
      <h3 class="text-center">
        {{ object_info.title }}
      </h3>
      <h6
        v-if="object_info.object_type"
        class="mx-auto mb-1 text-center text-muted text-uppercase"
      >
        {{ object_info.object_type.name[$i18n.locale] }}
      </h6>
      <div class="d-flex flex-column align-items-center mb-1">
        <span class="text-info text-uppercase">
          {{ $_dateTimeFormatter(object_info.created_at).split(',')[0] }}
        </span>
      </div>
    </div>
    <b-row class="text-center bg-white mx-0">
      <b-col
        cols="6"
        class="border-top border-right d-flex align-items-between flex-column py-50"
      >
        <b-card-text class="text-muted mb-25">
          {{ $t('objects.apartments') }}
        </b-card-text>
        <h3 class="font-weight-bolder mb-50">
          {{ object_info.apartment_count || $t('objects.not_created') }}
        </h3>
      </b-col>

      <b-col
        cols="6"
        class="border-top d-flex align-items-between flex-column py-50"
      >
        <b-card-text class="text-muted mb-25">
          {{ $t('objects.flats') }}
        </b-card-text>
        <h3
          v-if="object_info.flat_count"
          class="font-weight-bolder mb-0"
        >
          {{ object_info.flat_count }}
        </h3>
        <h5
          v-else
          class="font-weight-bolder mt-50 mb-0"
        >
          {{ $t('objects.not_created') }}
        </h5>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BCardText, BImg,
} from 'bootstrap-vue'
import extra from '@/mixins/extra'

export default {
  name: 'ObjectCard',
  components: {
    BCard, BRow, BCol, BCardText, BImg,
  },
  mixins: [extra],
  props: {
    object_info: {
      type: Object,
      required: true,
    },
  },
  methods: {
    buttonClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-knowledge-base.scss';
  .back-size-pos {
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }
  .back-overflow {
    overflow: hidden;
  }
</style>
